import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class ForumFindAllPosts extends baseRequest {
    constructor(forumConfiguration, successHandler, failureHandler) {
        super();
        this.name = 'ForumFindAllPosts';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.forumConfiguration = forumConfiguration;
        this.successHandler = successHandler;
        this.failureHandler = failureHandler;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call('posts', payload, 'get', {
            basePath: this.forumConfiguration.apiPath,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            stringifyData: true,
        });
    }

    onSuccess() {
        this.successHandler(this.response);
    }

    onFailure(response, methodName = '') {
        super.onFailure(response, methodName);
        this.failureHandler();
    }

    handleServerError(error) {
        super.handleServerError(error);
        this.failureHandler();
    }
}

export default ForumFindAllPosts;
